/* tslint:disable */
/* eslint-disable */
/**
 * Mercatus Portal
 * Mercatus Portal
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@gomercatus.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { CountAndThreshold } from '../model';
// @ts-ignore
import { EntityAssumptionValue } from '../model';
// @ts-ignore
import { EntityCountSummary } from '../model';
// @ts-ignore
import { EntityGroupedValue } from '../model';
// @ts-ignore
import { Perspective } from '../model';
// @ts-ignore
import { SliceEntityCard } from '../model';
/**
 * NavigatorApi - axios parameter creator
 * @export
 */
export const NavigatorApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Gets count for adhoc perspective with -1 for > 100k
         * @summary Gets count of entities matching perspective
         * @param {Perspective} perspective Perspective for which to get entity values
         * @param {number} [page] 
         * @param {string} [search] 
         * @param {number} [parentEntityId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityCountForAdHocPerspective: async (perspective: Perspective, page?: number, search?: string, parentEntityId?: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'perspective' is not null or undefined
            assertParamExists('getEntityCountForAdHocPerspective', 'perspective', perspective)
            const localVarPath = `/navigator/navent/entityCount`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (parentEntityId !== undefined) {
                localVarQueryParameter['parentEntityId'] = parentEntityId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(perspective, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Gets count for given perspective with -1 for > 100k
         * @summary Gets count of entities matching perspective
         * @param {number} perspective ID of perspective for which to fetch the entity values
         * @param {number} [page] 
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityCountForSavedPerspective: async (perspective: number, page?: number, search?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'perspective' is not null or undefined
            assertParamExists('getEntityCountForSavedPerspective', 'perspective', perspective)
            const localVarPath = `/navigator/navent/entityCount`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (perspective !== undefined) {
                localVarQueryParameter['perspective'] = perspective;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Gets entity count summary for given perspective
         * @summary Gets entity count summary
         * @param {Perspective} perspective Perspective for which to get entity count summary
         * @param {number} [page] 
         * @param {string} [search] 
         * @param {number} [parentEntityId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityCountSummaryForAdHocPerspective: async (perspective: Perspective, page?: number, search?: string, parentEntityId?: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'perspective' is not null or undefined
            assertParamExists('getEntityCountSummaryForAdHocPerspective', 'perspective', perspective)
            const localVarPath = `/navigator/navent/entityCountSummary`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (parentEntityId !== undefined) {
                localVarQueryParameter['parentEntityId'] = parentEntityId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(perspective, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Gets entity count summary for given perspective
         * @summary Gets entity count summary
         * @param {number} perspective ID of perspective for which to fetch the entity count summary
         * @param {number} [page] 
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityCountSummaryForSavedPerspective: async (perspective: number, page?: number, search?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'perspective' is not null or undefined
            assertParamExists('getEntityCountSummaryForSavedPerspective', 'perspective', perspective)
            const localVarPath = `/navigator/navent/entityCountSummary`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (perspective !== undefined) {
                localVarQueryParameter['perspective'] = perspective;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Gets entity and entity assumption values for given perspective
         * @summary Gets entity values
         * @param {Perspective} perspective Perspective for which to get entity values
         * @param {number} [page] 
         * @param {string} [search] 
         * @param {number} [parentEntityId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityValuesForAdHocPerspective: async (perspective: Perspective, page?: number, search?: string, parentEntityId?: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'perspective' is not null or undefined
            assertParamExists('getEntityValuesForAdHocPerspective', 'perspective', perspective)
            const localVarPath = `/navigator/navent/entityValues`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (parentEntityId !== undefined) {
                localVarQueryParameter['parentEntityId'] = parentEntityId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(perspective, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Gets CSV entity and entity assumption values for given perspective
         * @summary Gets entity values as CSV
         * @param {Perspective} perspective Perspective for which to get entity values
         * @param {string} [search] 
         * @param {number} [parentEntityId] 
         * @param {number} [firstColumn] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityValuesForAdHocPerspectiveAsCsv: async (perspective: Perspective, search?: string, parentEntityId?: number, firstColumn?: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'perspective' is not null or undefined
            assertParamExists('getEntityValuesForAdHocPerspectiveAsCsv', 'perspective', perspective)
            const localVarPath = `/navigator/navent/entityValues/csv`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (parentEntityId !== undefined) {
                localVarQueryParameter['parentEntityId'] = parentEntityId;
            }

            if (firstColumn !== undefined) {
                localVarQueryParameter['firstColumn'] = firstColumn;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(perspective, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Gets CSV entity and entity assumption values for given perspective
         * @summary Gets entity values as CSV resulting in email to user
         * @param {string} filename 
         * @param {Perspective} perspective Perspective for which to get entity values
         * @param {string} [search] 
         * @param {number} [parentEntityId] 
         * @param {number} [firstColumn] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityValuesForAdHocPerspectiveAsCsvBulk: async (filename: string, perspective: Perspective, search?: string, parentEntityId?: number, firstColumn?: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'filename' is not null or undefined
            assertParamExists('getEntityValuesForAdHocPerspectiveAsCsvBulk', 'filename', filename)
            // verify required parameter 'perspective' is not null or undefined
            assertParamExists('getEntityValuesForAdHocPerspectiveAsCsvBulk', 'perspective', perspective)
            const localVarPath = `/navigator/navent/entityValues/csv/bulk`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (parentEntityId !== undefined) {
                localVarQueryParameter['parentEntityId'] = parentEntityId;
            }

            if (firstColumn !== undefined) {
                localVarQueryParameter['firstColumn'] = firstColumn;
            }

            if (filename !== undefined) {
                localVarQueryParameter['filename'] = filename;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(perspective, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Gets xla entity and entity assumption values for given perspective
         * @summary Gets entity values as xls template
         * @param {Perspective} perspective Perspective for which to get entity values
         * @param {string} [search] 
         * @param {number} [parentEntityId] 
         * @param {number} [firstColumn] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityValuesForAdHocPerspectiveAsExcelTemplate: async (perspective: Perspective, search?: string, parentEntityId?: number, firstColumn?: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'perspective' is not null or undefined
            assertParamExists('getEntityValuesForAdHocPerspectiveAsExcelTemplate', 'perspective', perspective)
            const localVarPath = `/navigator/navent/entityValues/excel`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (parentEntityId !== undefined) {
                localVarQueryParameter['parentEntityId'] = parentEntityId;
            }

            if (firstColumn !== undefined) {
                localVarQueryParameter['firstColumn'] = firstColumn;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(perspective, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Gets entity and entity assumption values for given perspective
         * @summary Gets entity values
         * @param {number} perspective ID of perspective for which to fetch the entity values
         * @param {number} [page] 
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityValuesForSavedPerspective: async (perspective: number, page?: number, search?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'perspective' is not null or undefined
            assertParamExists('getEntityValuesForSavedPerspective', 'perspective', perspective)
            const localVarPath = `/navigator/navent/entityValues`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (perspective !== undefined) {
                localVarQueryParameter['perspective'] = perspective;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Gets CSV entity and entity assumption values for given perspective
         * @summary Gets entity values as CSV
         * @param {number} perspective ID of perspective for which to fetch the entity values
         * @param {string} [search] 
         * @param {number} [firstColumn] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityValuesForSavedPerspectiveAsCsv: async (perspective: number, search?: string, firstColumn?: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'perspective' is not null or undefined
            assertParamExists('getEntityValuesForSavedPerspectiveAsCsv', 'perspective', perspective)
            const localVarPath = `/navigator/navent/entityValues/csv`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (perspective !== undefined) {
                localVarQueryParameter['perspective'] = perspective;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (firstColumn !== undefined) {
                localVarQueryParameter['firstColumn'] = firstColumn;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Gets CSV entity and entity assumption values for given perspective
         * @summary Gets entity values as CSV resulting in email to user
         * @param {number} perspective ID of perspective for which to fetch the entity values
         * @param {string} filename 
         * @param {string} [search] 
         * @param {number} [firstColumn] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityValuesForSavedPerspectiveAsCsvBulk: async (perspective: number, filename: string, search?: string, firstColumn?: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'perspective' is not null or undefined
            assertParamExists('getEntityValuesForSavedPerspectiveAsCsvBulk', 'perspective', perspective)
            // verify required parameter 'filename' is not null or undefined
            assertParamExists('getEntityValuesForSavedPerspectiveAsCsvBulk', 'filename', filename)
            const localVarPath = `/navigator/navent/entityValues/csv/bulk`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (perspective !== undefined) {
                localVarQueryParameter['perspective'] = perspective;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (firstColumn !== undefined) {
                localVarQueryParameter['firstColumn'] = firstColumn;
            }

            if (filename !== undefined) {
                localVarQueryParameter['filename'] = filename;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Gets xls entity and entity assumption values for given perspective
         * @summary Gets entity values as xls template
         * @param {number} perspective ID of perspective for which to fetch the entity values
         * @param {string} [search] 
         * @param {number} [firstColumn] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityValuesForSavedPerspectiveAsExcelTemplate: async (perspective: number, search?: string, firstColumn?: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'perspective' is not null or undefined
            assertParamExists('getEntityValuesForSavedPerspectiveAsExcelTemplate', 'perspective', perspective)
            const localVarPath = `/navigator/navent/entityValues/excel`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (perspective !== undefined) {
                localVarQueryParameter['perspective'] = perspective;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (firstColumn !== undefined) {
                localVarQueryParameter['firstColumn'] = firstColumn;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Gets entity values grouped by a single assumption for a given perspective
         * @summary Gets entity grouped values
         * @param {number} groupBy ID of assumption to group by
         * @param {Perspective} perspective Perspective for which to get grouped entity values
         * @param {string} [search] 
         * @param {'ASC' | 'DESC'} [direction] 
         * @param {number} [parentEntityId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityValuesGroupedForAdHocPerspective: async (groupBy: number, perspective: Perspective, search?: string, direction?: 'ASC' | 'DESC', parentEntityId?: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupBy' is not null or undefined
            assertParamExists('getEntityValuesGroupedForAdHocPerspective', 'groupBy', groupBy)
            // verify required parameter 'perspective' is not null or undefined
            assertParamExists('getEntityValuesGroupedForAdHocPerspective', 'perspective', perspective)
            const localVarPath = `/navigator/navent/entityValues/grouped`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (groupBy !== undefined) {
                localVarQueryParameter['groupBy'] = groupBy;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (direction !== undefined) {
                localVarQueryParameter['direction'] = direction;
            }

            if (parentEntityId !== undefined) {
                localVarQueryParameter['parentEntityId'] = parentEntityId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(perspective, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Gets entity values grouped by a single assumption value
         * @summary Get grouped entity values
         * @param {number} perspective ID of perspective for which to fetch entity values
         * @param {number} groupBy ID of assumption to group by
         * @param {string} [search] 
         * @param {'ASC' | 'DESC'} [direction] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityValuesGroupedForSavedPerspective: async (perspective: number, groupBy: number, search?: string, direction?: 'ASC' | 'DESC', options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'perspective' is not null or undefined
            assertParamExists('getEntityValuesGroupedForSavedPerspective', 'perspective', perspective)
            // verify required parameter 'groupBy' is not null or undefined
            assertParamExists('getEntityValuesGroupedForSavedPerspective', 'groupBy', groupBy)
            const localVarPath = `/navigator/navent/entityValues/grouped`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (perspective !== undefined) {
                localVarQueryParameter['perspective'] = perspective;
            }

            if (groupBy !== undefined) {
                localVarQueryParameter['groupBy'] = groupBy;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (direction !== undefined) {
                localVarQueryParameter['direction'] = direction;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update entity assumption value by entityId and assumptionId
         * @summary Update entity assumption value
         * @param {number} entityId ID of entity
         * @param {number} assumptionId ID of assumption
         * @param {EntityAssumptionValue} entityAssumptionValue Updated value of entity assumption
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEntityAssumption: async (entityId: number, assumptionId: number, entityAssumptionValue: EntityAssumptionValue, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'entityId' is not null or undefined
            assertParamExists('updateEntityAssumption', 'entityId', entityId)
            // verify required parameter 'assumptionId' is not null or undefined
            assertParamExists('updateEntityAssumption', 'assumptionId', assumptionId)
            // verify required parameter 'entityAssumptionValue' is not null or undefined
            assertParamExists('updateEntityAssumption', 'entityAssumptionValue', entityAssumptionValue)
            const localVarPath = `/navigator/entities/{entityId}/assumptions/{assumptionId}`
                .replace(`{${"entityId"}}`, encodeURIComponent(String(entityId)))
                .replace(`{${"assumptionId"}}`, encodeURIComponent(String(assumptionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(entityAssumptionValue, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * NavigatorApi - functional programming interface
 * @export
 */
export const NavigatorApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = NavigatorApiAxiosParamCreator(configuration)
    return {
        /**
         * Gets count for adhoc perspective with -1 for > 100k
         * @summary Gets count of entities matching perspective
         * @param {Perspective} perspective Perspective for which to get entity values
         * @param {number} [page] 
         * @param {string} [search] 
         * @param {number} [parentEntityId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEntityCountForAdHocPerspective(perspective: Perspective, page?: number, search?: string, parentEntityId?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CountAndThreshold>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEntityCountForAdHocPerspective(perspective, page, search, parentEntityId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Gets count for given perspective with -1 for > 100k
         * @summary Gets count of entities matching perspective
         * @param {number} perspective ID of perspective for which to fetch the entity values
         * @param {number} [page] 
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEntityCountForSavedPerspective(perspective: number, page?: number, search?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CountAndThreshold>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEntityCountForSavedPerspective(perspective, page, search, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Gets entity count summary for given perspective
         * @summary Gets entity count summary
         * @param {Perspective} perspective Perspective for which to get entity count summary
         * @param {number} [page] 
         * @param {string} [search] 
         * @param {number} [parentEntityId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEntityCountSummaryForAdHocPerspective(perspective: Perspective, page?: number, search?: string, parentEntityId?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EntityCountSummary>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEntityCountSummaryForAdHocPerspective(perspective, page, search, parentEntityId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Gets entity count summary for given perspective
         * @summary Gets entity count summary
         * @param {number} perspective ID of perspective for which to fetch the entity count summary
         * @param {number} [page] 
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEntityCountSummaryForSavedPerspective(perspective: number, page?: number, search?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EntityCountSummary>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEntityCountSummaryForSavedPerspective(perspective, page, search, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Gets entity and entity assumption values for given perspective
         * @summary Gets entity values
         * @param {Perspective} perspective Perspective for which to get entity values
         * @param {number} [page] 
         * @param {string} [search] 
         * @param {number} [parentEntityId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEntityValuesForAdHocPerspective(perspective: Perspective, page?: number, search?: string, parentEntityId?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SliceEntityCard>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEntityValuesForAdHocPerspective(perspective, page, search, parentEntityId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Gets CSV entity and entity assumption values for given perspective
         * @summary Gets entity values as CSV
         * @param {Perspective} perspective Perspective for which to get entity values
         * @param {string} [search] 
         * @param {number} [parentEntityId] 
         * @param {number} [firstColumn] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEntityValuesForAdHocPerspectiveAsCsv(perspective: Perspective, search?: string, parentEntityId?: number, firstColumn?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEntityValuesForAdHocPerspectiveAsCsv(perspective, search, parentEntityId, firstColumn, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Gets CSV entity and entity assumption values for given perspective
         * @summary Gets entity values as CSV resulting in email to user
         * @param {string} filename 
         * @param {Perspective} perspective Perspective for which to get entity values
         * @param {string} [search] 
         * @param {number} [parentEntityId] 
         * @param {number} [firstColumn] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEntityValuesForAdHocPerspectiveAsCsvBulk(filename: string, perspective: Perspective, search?: string, parentEntityId?: number, firstColumn?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEntityValuesForAdHocPerspectiveAsCsvBulk(filename, perspective, search, parentEntityId, firstColumn, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Gets xla entity and entity assumption values for given perspective
         * @summary Gets entity values as xls template
         * @param {Perspective} perspective Perspective for which to get entity values
         * @param {string} [search] 
         * @param {number} [parentEntityId] 
         * @param {number} [firstColumn] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEntityValuesForAdHocPerspectiveAsExcelTemplate(perspective: Perspective, search?: string, parentEntityId?: number, firstColumn?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEntityValuesForAdHocPerspectiveAsExcelTemplate(perspective, search, parentEntityId, firstColumn, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Gets entity and entity assumption values for given perspective
         * @summary Gets entity values
         * @param {number} perspective ID of perspective for which to fetch the entity values
         * @param {number} [page] 
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEntityValuesForSavedPerspective(perspective: number, page?: number, search?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SliceEntityCard>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEntityValuesForSavedPerspective(perspective, page, search, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Gets CSV entity and entity assumption values for given perspective
         * @summary Gets entity values as CSV
         * @param {number} perspective ID of perspective for which to fetch the entity values
         * @param {string} [search] 
         * @param {number} [firstColumn] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEntityValuesForSavedPerspectiveAsCsv(perspective: number, search?: string, firstColumn?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEntityValuesForSavedPerspectiveAsCsv(perspective, search, firstColumn, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Gets CSV entity and entity assumption values for given perspective
         * @summary Gets entity values as CSV resulting in email to user
         * @param {number} perspective ID of perspective for which to fetch the entity values
         * @param {string} filename 
         * @param {string} [search] 
         * @param {number} [firstColumn] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEntityValuesForSavedPerspectiveAsCsvBulk(perspective: number, filename: string, search?: string, firstColumn?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEntityValuesForSavedPerspectiveAsCsvBulk(perspective, filename, search, firstColumn, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Gets xls entity and entity assumption values for given perspective
         * @summary Gets entity values as xls template
         * @param {number} perspective ID of perspective for which to fetch the entity values
         * @param {string} [search] 
         * @param {number} [firstColumn] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEntityValuesForSavedPerspectiveAsExcelTemplate(perspective: number, search?: string, firstColumn?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEntityValuesForSavedPerspectiveAsExcelTemplate(perspective, search, firstColumn, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Gets entity values grouped by a single assumption for a given perspective
         * @summary Gets entity grouped values
         * @param {number} groupBy ID of assumption to group by
         * @param {Perspective} perspective Perspective for which to get grouped entity values
         * @param {string} [search] 
         * @param {'ASC' | 'DESC'} [direction] 
         * @param {number} [parentEntityId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEntityValuesGroupedForAdHocPerspective(groupBy: number, perspective: Perspective, search?: string, direction?: 'ASC' | 'DESC', parentEntityId?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EntityGroupedValue>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEntityValuesGroupedForAdHocPerspective(groupBy, perspective, search, direction, parentEntityId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Gets entity values grouped by a single assumption value
         * @summary Get grouped entity values
         * @param {number} perspective ID of perspective for which to fetch entity values
         * @param {number} groupBy ID of assumption to group by
         * @param {string} [search] 
         * @param {'ASC' | 'DESC'} [direction] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEntityValuesGroupedForSavedPerspective(perspective: number, groupBy: number, search?: string, direction?: 'ASC' | 'DESC', options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EntityGroupedValue>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEntityValuesGroupedForSavedPerspective(perspective, groupBy, search, direction, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Update entity assumption value by entityId and assumptionId
         * @summary Update entity assumption value
         * @param {number} entityId ID of entity
         * @param {number} assumptionId ID of assumption
         * @param {EntityAssumptionValue} entityAssumptionValue Updated value of entity assumption
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateEntityAssumption(entityId: number, assumptionId: number, entityAssumptionValue: EntityAssumptionValue, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EntityAssumptionValue>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateEntityAssumption(entityId, assumptionId, entityAssumptionValue, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * NavigatorApi - factory interface
 * @export
 */
export const NavigatorApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = NavigatorApiFp(configuration)
    return {
        /**
         * Gets count for adhoc perspective with -1 for > 100k
         * @summary Gets count of entities matching perspective
         * @param {Perspective} perspective Perspective for which to get entity values
         * @param {number} [page] 
         * @param {string} [search] 
         * @param {number} [parentEntityId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityCountForAdHocPerspective(perspective: Perspective, page?: number, search?: string, parentEntityId?: number, options?: any): AxiosPromise<CountAndThreshold> {
            return localVarFp.getEntityCountForAdHocPerspective(perspective, page, search, parentEntityId, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets count for given perspective with -1 for > 100k
         * @summary Gets count of entities matching perspective
         * @param {number} perspective ID of perspective for which to fetch the entity values
         * @param {number} [page] 
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityCountForSavedPerspective(perspective: number, page?: number, search?: string, options?: any): AxiosPromise<CountAndThreshold> {
            return localVarFp.getEntityCountForSavedPerspective(perspective, page, search, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets entity count summary for given perspective
         * @summary Gets entity count summary
         * @param {Perspective} perspective Perspective for which to get entity count summary
         * @param {number} [page] 
         * @param {string} [search] 
         * @param {number} [parentEntityId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityCountSummaryForAdHocPerspective(perspective: Perspective, page?: number, search?: string, parentEntityId?: number, options?: any): AxiosPromise<EntityCountSummary> {
            return localVarFp.getEntityCountSummaryForAdHocPerspective(perspective, page, search, parentEntityId, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets entity count summary for given perspective
         * @summary Gets entity count summary
         * @param {number} perspective ID of perspective for which to fetch the entity count summary
         * @param {number} [page] 
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityCountSummaryForSavedPerspective(perspective: number, page?: number, search?: string, options?: any): AxiosPromise<EntityCountSummary> {
            return localVarFp.getEntityCountSummaryForSavedPerspective(perspective, page, search, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets entity and entity assumption values for given perspective
         * @summary Gets entity values
         * @param {Perspective} perspective Perspective for which to get entity values
         * @param {number} [page] 
         * @param {string} [search] 
         * @param {number} [parentEntityId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityValuesForAdHocPerspective(perspective: Perspective, page?: number, search?: string, parentEntityId?: number, options?: any): AxiosPromise<SliceEntityCard> {
            return localVarFp.getEntityValuesForAdHocPerspective(perspective, page, search, parentEntityId, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets CSV entity and entity assumption values for given perspective
         * @summary Gets entity values as CSV
         * @param {Perspective} perspective Perspective for which to get entity values
         * @param {string} [search] 
         * @param {number} [parentEntityId] 
         * @param {number} [firstColumn] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityValuesForAdHocPerspectiveAsCsv(perspective: Perspective, search?: string, parentEntityId?: number, firstColumn?: number, options?: any): AxiosPromise<any> {
            return localVarFp.getEntityValuesForAdHocPerspectiveAsCsv(perspective, search, parentEntityId, firstColumn, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets CSV entity and entity assumption values for given perspective
         * @summary Gets entity values as CSV resulting in email to user
         * @param {string} filename 
         * @param {Perspective} perspective Perspective for which to get entity values
         * @param {string} [search] 
         * @param {number} [parentEntityId] 
         * @param {number} [firstColumn] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityValuesForAdHocPerspectiveAsCsvBulk(filename: string, perspective: Perspective, search?: string, parentEntityId?: number, firstColumn?: number, options?: any): AxiosPromise<void> {
            return localVarFp.getEntityValuesForAdHocPerspectiveAsCsvBulk(filename, perspective, search, parentEntityId, firstColumn, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets xla entity and entity assumption values for given perspective
         * @summary Gets entity values as xls template
         * @param {Perspective} perspective Perspective for which to get entity values
         * @param {string} [search] 
         * @param {number} [parentEntityId] 
         * @param {number} [firstColumn] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityValuesForAdHocPerspectiveAsExcelTemplate(perspective: Perspective, search?: string, parentEntityId?: number, firstColumn?: number, options?: any): AxiosPromise<any> {
            return localVarFp.getEntityValuesForAdHocPerspectiveAsExcelTemplate(perspective, search, parentEntityId, firstColumn, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets entity and entity assumption values for given perspective
         * @summary Gets entity values
         * @param {number} perspective ID of perspective for which to fetch the entity values
         * @param {number} [page] 
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityValuesForSavedPerspective(perspective: number, page?: number, search?: string, options?: any): AxiosPromise<SliceEntityCard> {
            return localVarFp.getEntityValuesForSavedPerspective(perspective, page, search, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets CSV entity and entity assumption values for given perspective
         * @summary Gets entity values as CSV
         * @param {number} perspective ID of perspective for which to fetch the entity values
         * @param {string} [search] 
         * @param {number} [firstColumn] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityValuesForSavedPerspectiveAsCsv(perspective: number, search?: string, firstColumn?: number, options?: any): AxiosPromise<any> {
            return localVarFp.getEntityValuesForSavedPerspectiveAsCsv(perspective, search, firstColumn, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets CSV entity and entity assumption values for given perspective
         * @summary Gets entity values as CSV resulting in email to user
         * @param {number} perspective ID of perspective for which to fetch the entity values
         * @param {string} filename 
         * @param {string} [search] 
         * @param {number} [firstColumn] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityValuesForSavedPerspectiveAsCsvBulk(perspective: number, filename: string, search?: string, firstColumn?: number, options?: any): AxiosPromise<void> {
            return localVarFp.getEntityValuesForSavedPerspectiveAsCsvBulk(perspective, filename, search, firstColumn, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets xls entity and entity assumption values for given perspective
         * @summary Gets entity values as xls template
         * @param {number} perspective ID of perspective for which to fetch the entity values
         * @param {string} [search] 
         * @param {number} [firstColumn] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityValuesForSavedPerspectiveAsExcelTemplate(perspective: number, search?: string, firstColumn?: number, options?: any): AxiosPromise<any> {
            return localVarFp.getEntityValuesForSavedPerspectiveAsExcelTemplate(perspective, search, firstColumn, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets entity values grouped by a single assumption for a given perspective
         * @summary Gets entity grouped values
         * @param {number} groupBy ID of assumption to group by
         * @param {Perspective} perspective Perspective for which to get grouped entity values
         * @param {string} [search] 
         * @param {'ASC' | 'DESC'} [direction] 
         * @param {number} [parentEntityId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityValuesGroupedForAdHocPerspective(groupBy: number, perspective: Perspective, search?: string, direction?: 'ASC' | 'DESC', parentEntityId?: number, options?: any): AxiosPromise<Array<EntityGroupedValue>> {
            return localVarFp.getEntityValuesGroupedForAdHocPerspective(groupBy, perspective, search, direction, parentEntityId, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets entity values grouped by a single assumption value
         * @summary Get grouped entity values
         * @param {number} perspective ID of perspective for which to fetch entity values
         * @param {number} groupBy ID of assumption to group by
         * @param {string} [search] 
         * @param {'ASC' | 'DESC'} [direction] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityValuesGroupedForSavedPerspective(perspective: number, groupBy: number, search?: string, direction?: 'ASC' | 'DESC', options?: any): AxiosPromise<Array<EntityGroupedValue>> {
            return localVarFp.getEntityValuesGroupedForSavedPerspective(perspective, groupBy, search, direction, options).then((request) => request(axios, basePath));
        },
        /**
         * Update entity assumption value by entityId and assumptionId
         * @summary Update entity assumption value
         * @param {number} entityId ID of entity
         * @param {number} assumptionId ID of assumption
         * @param {EntityAssumptionValue} entityAssumptionValue Updated value of entity assumption
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEntityAssumption(entityId: number, assumptionId: number, entityAssumptionValue: EntityAssumptionValue, options?: any): AxiosPromise<EntityAssumptionValue> {
            return localVarFp.updateEntityAssumption(entityId, assumptionId, entityAssumptionValue, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * NavigatorApi - object-oriented interface
 * @export
 * @class NavigatorApi
 * @extends {BaseAPI}
 */
export class NavigatorApi extends BaseAPI {
    /**
     * Gets count for adhoc perspective with -1 for > 100k
     * @summary Gets count of entities matching perspective
     * @param {Perspective} perspective Perspective for which to get entity values
     * @param {number} [page] 
     * @param {string} [search] 
     * @param {number} [parentEntityId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NavigatorApi
     */
    public getEntityCountForAdHocPerspective(perspective: Perspective, page?: number, search?: string, parentEntityId?: number, options?: any) {
        return NavigatorApiFp(this.configuration).getEntityCountForAdHocPerspective(perspective, page, search, parentEntityId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Gets count for given perspective with -1 for > 100k
     * @summary Gets count of entities matching perspective
     * @param {number} perspective ID of perspective for which to fetch the entity values
     * @param {number} [page] 
     * @param {string} [search] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NavigatorApi
     */
    public getEntityCountForSavedPerspective(perspective: number, page?: number, search?: string, options?: any) {
        return NavigatorApiFp(this.configuration).getEntityCountForSavedPerspective(perspective, page, search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Gets entity count summary for given perspective
     * @summary Gets entity count summary
     * @param {Perspective} perspective Perspective for which to get entity count summary
     * @param {number} [page] 
     * @param {string} [search] 
     * @param {number} [parentEntityId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NavigatorApi
     */
    public getEntityCountSummaryForAdHocPerspective(perspective: Perspective, page?: number, search?: string, parentEntityId?: number, options?: any) {
        return NavigatorApiFp(this.configuration).getEntityCountSummaryForAdHocPerspective(perspective, page, search, parentEntityId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Gets entity count summary for given perspective
     * @summary Gets entity count summary
     * @param {number} perspective ID of perspective for which to fetch the entity count summary
     * @param {number} [page] 
     * @param {string} [search] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NavigatorApi
     */
    public getEntityCountSummaryForSavedPerspective(perspective: number, page?: number, search?: string, options?: any) {
        return NavigatorApiFp(this.configuration).getEntityCountSummaryForSavedPerspective(perspective, page, search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Gets entity and entity assumption values for given perspective
     * @summary Gets entity values
     * @param {Perspective} perspective Perspective for which to get entity values
     * @param {number} [page] 
     * @param {string} [search] 
     * @param {number} [parentEntityId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NavigatorApi
     */
    public getEntityValuesForAdHocPerspective(perspective: Perspective, page?: number, search?: string, parentEntityId?: number, options?: any) {
        return NavigatorApiFp(this.configuration).getEntityValuesForAdHocPerspective(perspective, page, search, parentEntityId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Gets CSV entity and entity assumption values for given perspective
     * @summary Gets entity values as CSV
     * @param {Perspective} perspective Perspective for which to get entity values
     * @param {string} [search] 
     * @param {number} [parentEntityId] 
     * @param {number} [firstColumn] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NavigatorApi
     */
    public getEntityValuesForAdHocPerspectiveAsCsv(perspective: Perspective, search?: string, parentEntityId?: number, firstColumn?: number, options?: any) {
        return NavigatorApiFp(this.configuration).getEntityValuesForAdHocPerspectiveAsCsv(perspective, search, parentEntityId, firstColumn, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Gets CSV entity and entity assumption values for given perspective
     * @summary Gets entity values as CSV resulting in email to user
     * @param {string} filename 
     * @param {Perspective} perspective Perspective for which to get entity values
     * @param {string} [search] 
     * @param {number} [parentEntityId] 
     * @param {number} [firstColumn] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NavigatorApi
     */
    public getEntityValuesForAdHocPerspectiveAsCsvBulk(filename: string, perspective: Perspective, search?: string, parentEntityId?: number, firstColumn?: number, options?: any) {
        return NavigatorApiFp(this.configuration).getEntityValuesForAdHocPerspectiveAsCsvBulk(filename, perspective, search, parentEntityId, firstColumn, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Gets xla entity and entity assumption values for given perspective
     * @summary Gets entity values as xls template
     * @param {Perspective} perspective Perspective for which to get entity values
     * @param {string} [search] 
     * @param {number} [parentEntityId] 
     * @param {number} [firstColumn] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NavigatorApi
     */
    public getEntityValuesForAdHocPerspectiveAsExcelTemplate(perspective: Perspective, search?: string, parentEntityId?: number, firstColumn?: number, options?: any) {
        return NavigatorApiFp(this.configuration).getEntityValuesForAdHocPerspectiveAsExcelTemplate(perspective, search, parentEntityId, firstColumn, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Gets entity and entity assumption values for given perspective
     * @summary Gets entity values
     * @param {number} perspective ID of perspective for which to fetch the entity values
     * @param {number} [page] 
     * @param {string} [search] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NavigatorApi
     */
    public getEntityValuesForSavedPerspective(perspective: number, page?: number, search?: string, options?: any) {
        return NavigatorApiFp(this.configuration).getEntityValuesForSavedPerspective(perspective, page, search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Gets CSV entity and entity assumption values for given perspective
     * @summary Gets entity values as CSV
     * @param {number} perspective ID of perspective for which to fetch the entity values
     * @param {string} [search] 
     * @param {number} [firstColumn] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NavigatorApi
     */
    public getEntityValuesForSavedPerspectiveAsCsv(perspective: number, search?: string, firstColumn?: number, options?: any) {
        return NavigatorApiFp(this.configuration).getEntityValuesForSavedPerspectiveAsCsv(perspective, search, firstColumn, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Gets CSV entity and entity assumption values for given perspective
     * @summary Gets entity values as CSV resulting in email to user
     * @param {number} perspective ID of perspective for which to fetch the entity values
     * @param {string} filename 
     * @param {string} [search] 
     * @param {number} [firstColumn] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NavigatorApi
     */
    public getEntityValuesForSavedPerspectiveAsCsvBulk(perspective: number, filename: string, search?: string, firstColumn?: number, options?: any) {
        return NavigatorApiFp(this.configuration).getEntityValuesForSavedPerspectiveAsCsvBulk(perspective, filename, search, firstColumn, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Gets xls entity and entity assumption values for given perspective
     * @summary Gets entity values as xls template
     * @param {number} perspective ID of perspective for which to fetch the entity values
     * @param {string} [search] 
     * @param {number} [firstColumn] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NavigatorApi
     */
    public getEntityValuesForSavedPerspectiveAsExcelTemplate(perspective: number, search?: string, firstColumn?: number, options?: any) {
        return NavigatorApiFp(this.configuration).getEntityValuesForSavedPerspectiveAsExcelTemplate(perspective, search, firstColumn, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Gets entity values grouped by a single assumption for a given perspective
     * @summary Gets entity grouped values
     * @param {number} groupBy ID of assumption to group by
     * @param {Perspective} perspective Perspective for which to get grouped entity values
     * @param {string} [search] 
     * @param {'ASC' | 'DESC'} [direction] 
     * @param {number} [parentEntityId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NavigatorApi
     */
    public getEntityValuesGroupedForAdHocPerspective(groupBy: number, perspective: Perspective, search?: string, direction?: 'ASC' | 'DESC', parentEntityId?: number, options?: any) {
        return NavigatorApiFp(this.configuration).getEntityValuesGroupedForAdHocPerspective(groupBy, perspective, search, direction, parentEntityId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Gets entity values grouped by a single assumption value
     * @summary Get grouped entity values
     * @param {number} perspective ID of perspective for which to fetch entity values
     * @param {number} groupBy ID of assumption to group by
     * @param {string} [search] 
     * @param {'ASC' | 'DESC'} [direction] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NavigatorApi
     */
    public getEntityValuesGroupedForSavedPerspective(perspective: number, groupBy: number, search?: string, direction?: 'ASC' | 'DESC', options?: any) {
        return NavigatorApiFp(this.configuration).getEntityValuesGroupedForSavedPerspective(perspective, groupBy, search, direction, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update entity assumption value by entityId and assumptionId
     * @summary Update entity assumption value
     * @param {number} entityId ID of entity
     * @param {number} assumptionId ID of assumption
     * @param {EntityAssumptionValue} entityAssumptionValue Updated value of entity assumption
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NavigatorApi
     */
    public updateEntityAssumption(entityId: number, assumptionId: number, entityAssumptionValue: EntityAssumptionValue, options?: any) {
        return NavigatorApiFp(this.configuration).updateEntityAssumption(entityId, assumptionId, entityAssumptionValue, options).then((request) => request(this.axios, this.basePath));
    }
}
